export default __webpack_public_path__ + "static/media/Grizzly Brigandine.aad9dc67.jpg";